import { Component, ChangeDetectorRef } from '@angular/core';
import { AreaComum, TipoArea, Area, AreaAdmin } from '../../models/area';
import { Contato } from '../../models/contato';
import { Subscription, combineLatest } from 'rxjs';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { AreaAdminLocalProvider } from '../../providers/area-admin-local/area-admin-local';
import { IonicPage, NavController, PopoverController } from 'ionic-angular';
import { AdicionarContatoPage } from '../adicionar-contato/adicionar-contato';
import { FotoProvider } from '../../providers/foto/foto';
import { MenuPopoverComponent } from '../../components/menu-popup/menu-popover';

@IonicPage()
@Component({
  selector: 'page-lista-conversas',
  templateUrl: 'lista-conversas.html',
})
export class ListaConversasPage {

  public conversaSelecionada: any;
  public setores: Area[];
  public centrosDeCusto: Area[];
  public contatos: Contato[];
  private subscriptions: Subscription;
  public empresa: any;

  constructor(private changeDetectorRef: ChangeDetectorRef, 
    private areaLocalProvider: AreaLocalProvider, 
    private contatoLocalProvider: ContatoLocalProvider,
    private empresaLocalProvider: EmpresaLocalProvider,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
    private navCtrl: NavController,
    private fotoProvider: FotoProvider,
    private popoverController: PopoverController) {
    this.subscriptions = new Subscription();
  } 

  ngOnInit() {
    const subEmpresa = this.empresaLocalProvider.$empresa.subscribe(
      (empresa) => {
        this.empresa = empresa;
      }
    )
    const subContatos = this.contatoLocalProvider.$contatos.subscribe(
      (contatos: Contato[]) => {
        this.atualizarContatos(this.contatoLocalProvider.getContatos());
      }
    );
    const subAreas = combineLatest(this.areaLocalProvider.$areas, this.areaAdminLocalProvider.$areas).subscribe(
      (result) => {
       // this.atualizarAreas([...result[0], ...result[1]])

       // quando o app é removido da memória e aberto de novo o resolt[0] vem vazio, mas deveria ter valor
       // isso aqui é uma concerto temporario
       this.atualizarAreas([...this.areaLocalProvider.getAreas(), ...this.areaAdminLocalProvider.getAreas()]);
      }
    );
    this.subscriptions.add(subEmpresa);
    this.subscriptions.add(subContatos);
    this.subscriptions.add(subAreas);
  //  this.selecionarPrimeiroItem();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private selecionarPrimeiroItem() {
    if (this.setores && this.setores.length > 0) {
      this.conversaSelecionada = this.setores[0];
      this.selecionarArea(this.conversaSelecionada);
    } else if (this.centrosDeCusto && this.centrosDeCusto.length > 0) {
      this.conversaSelecionada = this.centrosDeCusto[0];
      this.selecionarArea(this.conversaSelecionada);
    } else if (this.contatos && this.contatos.length > 0) {
      this.conversaSelecionada = this.contatos[0];
      this.selecionarContato(this.conversaSelecionada);
    }
  }

  public selecionarArea(area: Area): void {
    this.conversaSelecionada = area;
   // this.areaSelecionada.emit(area);
  }

  public selecionarContato(contato: Contato): void {
    this.conversaSelecionada = contato;
//    this.contatoSelecionado.emit(contato);
  }

  private atualizarAreas(areas: Area[]): void {
    if (!areas) {
      return
    }
    const setores = [];
    const centrosDeCusto = [];
    for (const area of areas) {
      if (area.tipo == TipoArea.SETOR) {
        setores.push(area);
      } else {
        centrosDeCusto.push(area);
      }
    } 
    this.atualizarSetores(setores);
    this.atualizarCentrosDeCusto(centrosDeCusto);
  }

  private atualizarSetores(setores: Area[]): void {
    if (!setores) {
      return;
    }
    this.setores = this.ordenenarListaPorDataDaUltimaMensagem(setores);
    this.detectChanges();
  }

  private atualizarCentrosDeCusto(centrosDeCusto: Area[]): void {
    if (!centrosDeCusto) {
      return;
    }
    this.centrosDeCusto = this.ordenenarListaPorDataDaUltimaMensagem(centrosDeCusto);
    this.detectChanges();
  }

  private atualizarContatos(contatos: Contato[]): void {
    if (!contatos) {
      return;
    }
    this.contatos = this.ordenenarListaPorDataDaUltimaMensagem(contatos);
    this.detectChanges();
  }

  public isAreaComum(area: AreaComum | AreaAdmin): boolean {
    return 'mensagens' in area;
  }

  private ordenenarListaPorDataDaUltimaMensagem<T>(lista: T[]): T[] {
    return lista.sort((a: any, b: any) => {
      let timeA = 0;
      let timeB = 0;
      if (a.mensagens && a.mensagens.length > 0) {
       timeA = a.mensagens[a.mensagens.length - 1].dataHora
      }
      if (b.mensagens && b.mensagens.length > 0) {
        timeB = b.mensagens[b.mensagens.length - 1].dataHora
      }
      return timeB - timeA
    });
  }

  private detectChanges(): void {
    try {
      this.changeDetectorRef.detectChanges();
    } catch(err) {}
  }

  public trackByArea(index: number, s: any) {
    if ('mensagens' in s) {
      if (!s.mensagens || s.mensagens.length < 1) {
        return null;
      }
      const ultimaMensagem = s.mensagens[s.mensagens.length - 1];
      return `${ultimaMensagem.idEnvio}:${ultimaMensagem.statusMensagemLida}:${index}`;
    }
    return s;
  }

  public adicionarContato(): void {
    this.navCtrl.push(AdicionarContatoPage, {
      idUsuario: this.empresa.IdUsuario,
      idEmpresa: this.empresa.IdEmpresa
    });
  }

  public getImagemUsuario(): string {
    const hashImagem = this.empresa.HashImagem;
    if (hashImagem !== "") {
      return this.fotoProvider.getUrlImagemServidor(hashImagem);
    } else {
      return 'assets/img/usuario.png';
    }
  }

  public abrirMenu(event) {
    let popover = this.popoverController.create(MenuPopoverComponent);
    popover.present({
      ev: event
    });
  }

  public trackByContatos(index: number, c: Contato) {
    if (!c.mensagens || c.mensagens.length < 1) {
      return null;
    }
    const ultimaMensagem = c.mensagens[c.mensagens.length - 1];
    return `${ultimaMensagem.idEnvio}:${ultimaMensagem.statusMensagemLida}:${ultimaMensagem.statusMensagemRecebida}:${index}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-conversas/lista-conversas.ts